import PolicyAndTerms from "components/session/PolicyAndTerms";
import { SDM } from "models/InitiateSessionResponse";
import * as React from "react";
import {
  Card,
  CardBody,
  CardText,
  CardTitle,
  Col,
  Input,
  Row,
} from "reactstrap";
import "styles/login.scss";
import "../../styles/login.scss";
import authService from "../../utils/AuthService";
import SessionPanel from "../shared/SessionPanel";

const Login: React.FC<{
  users: SDM[];
  imagePath?: string;
  selectedUser?: SDM;
  onChangeUser: (user: SDM) => void;
  onLogin: () => void;
  onGoBack?: () => void;
  isLoading: boolean;
}> = ({
  users,
  imagePath,
  selectedUser,
  onChangeUser,
  onLogin,
  onGoBack,
  isLoading,
}) => {
    const [termsAccepted, setTermsAccepted] = React.useState(true);
    return (
      <SessionPanel
        image={imagePath}
        title={`Who would you like to continue as?`}
        onGoBack={onGoBack}
        primaryButton={{
          text: "Sign in",
          action: onLogin,
          isDisabled:
            !termsAccepted ||
            (!authService.getEmail() && !authService.getPhone()) ||
            !selectedUser,
        }}
        isLoading={isLoading}
      >
        {!!users &&
          users.map((m) => (
            <Card
              key={m.email}
              style={{ cursor: "default", backgroundColor: "#FFFFFF" }}
            >
              <CardBody>
                <Row>
                  <Col xs={2} className="d-flex align-items-center">
                    <Input
                      name={selectedUser?.email ? "emailAddress" : "phoneNumber"}
                      required={true}
                      defaultChecked={users.length === 1}
                      value={selectedUser?.email ?? selectedUser?.phone}
                      type="radio"
                      style={{ paddingLeft: 12, height: 32, width: 32 }}
                      onChange={() =>
                        onChangeUser(
                          users.find(
                            (f) =>
                              f.email === m.email! ||
                              (f.phone === m.phone && !f.email)
                          )!
                        )
                      }
                    />
                  </Col>
                  <Col xs={10} className="m-auto text-left">
                    <CardTitle tag="h6" className="text-start">
                      {m?.firstName} {m?.lastName}
                    </CardTitle>
                    <CardText style={{ fontSize: 14 }}>
                      {m?.email ?? m?.phone}
                    </CardText>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          ))}
        <div className="register-tou mt-2">
          {!!selectedUser && !selectedUser.hasLogin && (
            <Row>
              <Col xs={1} className="align-items-center" >
                <Input
                  type="checkbox"
                  style={{ fontSize: 16 }}
                  defaultChecked={termsAccepted}
                  onChange={(e) => {
                    setTermsAccepted(e.target.checked);
                  }}
                />
              </Col>
              <Col className="m-auto text-left"
                style={{ fontSize: 14 }}
              >
                I have read and agree to Marble's{" "}
                <PolicyAndTerms
                  src="https://www.marbleapi.com/privacy"
                  title="Privacy Policy"
                />{" "}
                and{" "}
                <PolicyAndTerms
                  src="https://www.marbleapi.com/product-tou"
                  title="Terms of Use"
                />
              </Col>
            </Row>
          )}
        </div>
        {!termsAccepted && (
          <div className="tou-error" style={{ fontSize: 14 }}>
            Please accept the terms and conditions.
          </div>
        )}
      </SessionPanel>
    );
  };

export default Login;
